import { parseIsoDate } from "../calc";

const TWO_DECIMALS = new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const INTEGER = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });
const CURRENCY = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });

/** ISO date (YYYY-MM-DD) to MM/DD/YYYY without timezone shifting. */
export function formatDate(value: string | null | undefined): string {
  const parts = parseIsoDate(value ?? null);
  if (!parts) return "";
  return `${String(parts.month).padStart(2, "0")}/${String(parts.day).padStart(2, "0")}/${parts.year}`;
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString("en-US", { month: "2-digit", day: "2-digit", year: "numeric", hour: "numeric", minute: "2-digit" });
}

export function formatRmm(value: number | null | undefined): string {
  if (value === null || value === undefined) return "";
  return TWO_DECIMALS.format(value);
}

export function formatInteger(value: number | null | undefined): string {
  if (value === null || value === undefined) return "";
  return INTEGER.format(value);
}

export function formatCurrency(value: number | null | undefined): string {
  if (value === null || value === undefined) return "";
  return CURRENCY.format(value);
}

export function formatHeight(feet: number | null, inches: number | null): string {
  if (feet === null) return "";
  return `${feet}'${inches ?? 0}"`;
}

export function fullName(first: string, last: string): string {
  const combined = `${first} ${last}`.trim();
  return combined === "" ? "Unnamed member" : combined;
}

/** Display name for a member; Spock cohorts read "Spock Doe" once, with the cohort shown on a badge. */
export function memberDisplayName(member: { firstName: string; lastName: string; memberType: string }): string {
  if (member.memberType === "SpockCohort") return "Spock Doe";
  return fullName(member.firstName, member.lastName);
}

export function initials(first: string, last: string): string {
  const letters = `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
  return letters === "" ? "?" : letters;
}

export function truncate(value: string | null | undefined, max: number): string {
  if (!value) return "";
  return value.length <= max ? value : `${value.slice(0, max - 1).trimEnd()}…`;
}

export function todayIso(): string {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
}

export function maskSsn(ssn: string | null): string | null {
  if (!ssn) return null;
  const digits = ssn.replace(/\D/g, "");
  if (digits.length < 4) return null;
  return `***-**-${digits.slice(-4)}`;
}
